export default __webpack_public_path__ + "media/facc69b51a31e4690f2563545e1f8f1222e8c1e5ac83db0483d308447810a5ed.svg";